var _style, _g, _span, _span2, _span3, _span4, _span5, _span6, _span7, _span8, _span9, _span0, _rect, _p, _rect2, _p2, _rect3, _p3, _rect4, _p4, _rect5, _p5, _rect6, _p6, _rect7, _p7, _rect8, _p8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-roledescription": "flowchart-v2",
    role: "graphics-document document",
    viewBox: "0 0 371.8125 729.5",
    style: {
      maxWidth: "371.812px",
      backgroundColor: "white"
    },
    className: "flowchart",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    id: "my-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "#my-svg{font-family:\"trebuchet ms\",verdana,arial,sans-serif;font-size:16px;fill:#333;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#my-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#my-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#my-svg .error-icon{fill:#552222;}#my-svg .error-text{fill:#552222;stroke:#552222;}#my-svg .edge-thickness-normal{stroke-width:1px;}#my-svg .edge-thickness-thick{stroke-width:3.5px;}#my-svg .edge-pattern-solid{stroke-dasharray:0;}#my-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#my-svg .edge-pattern-dashed{stroke-dasharray:3;}#my-svg .edge-pattern-dotted{stroke-dasharray:2;}#my-svg .marker{fill:#333333;stroke:#333333;}#my-svg .marker.cross{stroke:#333333;}#my-svg svg{font-family:\"trebuchet ms\",verdana,arial,sans-serif;font-size:16px;}#my-svg p{margin:0;}#my-svg .label{font-family:\"trebuchet ms\",verdana,arial,sans-serif;color:#333;}#my-svg .cluster-label text{fill:#333;}#my-svg .cluster-label span{color:#333;}#my-svg .cluster-label span p{background-color:transparent;}#my-svg .label text,#my-svg span{fill:#333;color:#333;}#my-svg .node rect,#my-svg .node circle,#my-svg .node ellipse,#my-svg .node polygon,#my-svg .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#my-svg .rough-node .label text,#my-svg .node .label text,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-anchor:middle;}#my-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#my-svg .rough-node .label,#my-svg .node .label,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-align:center;}#my-svg .node.clickable{cursor:pointer;}#my-svg .root .anchor path{fill:#333333!important;stroke-width:0;stroke:#333333;}#my-svg .arrowheadPath{fill:#333333;}#my-svg .edgePath .path{stroke:#333333;stroke-width:2.0px;}#my-svg .flowchart-link{stroke:#333333;fill:none;}#my-svg .edgeLabel{background-color:rgba(232,232,232, 0.8);text-align:center;}#my-svg .edgeLabel p{background-color:rgba(232,232,232, 0.8);}#my-svg .edgeLabel rect{opacity:0.5;background-color:rgba(232,232,232, 0.8);fill:rgba(232,232,232, 0.8);}#my-svg .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#my-svg .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#my-svg .cluster text{fill:#333;}#my-svg .cluster span{color:#333;}#my-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:\"trebuchet ms\",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#my-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#my-svg rect.text{fill:none;stroke-width:0;}#my-svg .icon-shape,#my-svg .image-shape{background-color:rgba(232,232,232, 0.8);text-align:center;}#my-svg .icon-shape p,#my-svg .image-shape p{background-color:rgba(232,232,232, 0.8);padding:2px;}#my-svg .icon-shape rect,#my-svg .image-shape rect{opacity:0.5;background-color:rgba(232,232,232, 0.8);fill:rgba(232,232,232, 0.8);}#my-svg :root{--mermaid-font-family:\"trebuchet ms\",verdana,arial,sans-serif;}#my-svg .default&gt;*{fill:#f2f0ff!important;line-height:1.2!important;}#my-svg .default span{fill:#f2f0ff!important;line-height:1.2!important;}#my-svg .first&gt;*{fill-opacity:0!important;}#my-svg .first span{fill-opacity:0!important;}#my-svg .last&gt;*{fill:#bfb6fc!important;}#my-svg .last span{fill:#bfb6fc!important;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 8,
    markerWidth: 8,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "my-svg_flowchart-v2-pointEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 10 5 L 0 10 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 8,
    markerWidth: 8,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 4.5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "my-svg_flowchart-v2-pointStart"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 5 L 10 10 L 10 0 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 11,
    markerWidth: 11,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 11,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "my-svg_flowchart-v2-circleEnd"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 11,
    markerWidth: 11,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: -1,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "my-svg_flowchart-v2-circleStart"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 11,
    markerWidth: 11,
    markerUnits: "userSpaceOnUse",
    refY: 5.2,
    refX: 12,
    viewBox: "0 0 11 11",
    className: "marker cross flowchart-v2",
    id: "my-svg_flowchart-v2-crossEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 l 9,9 M 10,1 l -9,9"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 11,
    markerWidth: 11,
    markerUnits: "userSpaceOnUse",
    refY: 5.2,
    refX: -1,
    viewBox: "0 0 11 11",
    className: "marker cross flowchart-v2",
    id: "my-svg_flowchart-v2-crossStart"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 l 9,9 M 10,1 l -9,9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L___start___ingest_0",
    d: "M219.012,42.188L219.012,67.188L219.012,88.188"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_analyze_pull_request_0",
    d: "M256.195,240.563L293.992,265.563L293.992,315.156L293.992,364.75L293.992,414.344L293.992,463.938L293.992,513.531L293.992,563.125L298.243,584.204"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_analyze_refactor_0",
    d: "M193.686,240.563L167.941,265.563L167.941,286.563"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_human_review___end___0",
    d: "M167.941,538.125L167.941,563.125L167.941,612.719L167.941,662.313L200.918,685.042"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_human_review_pull_request_0",
    d: "M235.082,536.33L313.992,563.125L309.742,584.204"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_human_review_refactor_0",
    d: "M200.165,488.938L232.922,463.938L232.922,414.344L232.922,364.75L203.345,342.177"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_ingest_analyze_0",
    d: "M219.012,141.375L219.012,166.375L219.012,187.375"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_post_refactor_analyze_human_review_0",
    d: "M102.961,438.938L102.961,463.938L132.538,486.511"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_refactor_post_refactor_analyze_0",
    d: "M135.717,339.75L102.961,364.75L102.961,385.75"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd)",
    style: {},
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_pull_request___end___0",
    d: "M303.992,637.313L303.992,662.313L262.948,685.354"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span || (_span = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span2 || (_span2 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span3 || (_span3 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span4 || (_span4 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span5 || (_span5 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span6 || (_span6 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span7 || (_span7 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span8 || (_span8 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span9 || (_span9 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "table-cell",
      whiteSpace: "nowrap",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    },
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, _span0 || (_span0 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.01171875, 25.09375)",
    id: "flowchart-__start__-0",
    className: "node default first"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 34.1875,
    width: 90.90625,
    y: -17.09375,
    x: -45.453125,
    ry: 17.09375,
    rx: 17.09375,
    style: {
      fill: "#f2f0ff !important",
      fillOpacity: "0 !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.6796875, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 67.359375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p || (_p = /*#__PURE__*/React.createElement("p", null, "__start__"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.01171875, 116.78125)",
    id: "flowchart-ingest-1",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 49.1875,
    width: 72.890625,
    y: -24.59375,
    x: -36.4453125,
    ry: 5,
    rx: 5,
    style: {
      fill: "#f2f0ff !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.4453125, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 42.890625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p2 || (_p2 = /*#__PURE__*/React.createElement("p", null, "ingest"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.01171875, 215.96875)",
    id: "flowchart-analyze-2",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 49.1875,
    width: 84.484375,
    y: -24.59375,
    x: -42.2421875,
    ry: 5,
    rx: 5,
    style: {
      fill: "#f2f0ff !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.2421875, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 54.484375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p3 || (_p3 = /*#__PURE__*/React.createElement("p", null, "analyze"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.94140625, 315.15625)",
    id: "flowchart-refactor-3",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 49.1875,
    width: 88.34375,
    y: -24.59375,
    x: -44.171875,
    ry: 5,
    rx: 5,
    style: {
      fill: "#f2f0ff !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.171875, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 58.34375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p4 || (_p4 = /*#__PURE__*/React.createElement("p", null, "refactor"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.9609375, 414.34375)",
    id: "flowchart-post_refactor_analyze-4",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 49.1875,
    width: 189.921875,
    y: -24.59375,
    x: -94.9609375,
    ry: 5,
    rx: 5,
    style: {
      fill: "#f2f0ff !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.9609375, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 159.921875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p5 || (_p5 = /*#__PURE__*/React.createElement("p", null, "post_refactor_analyze"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.94140625, 513.53125)",
    id: "flowchart-human_review-5",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 49.1875,
    width: 134.28125,
    y: -24.59375,
    x: -67.140625,
    ry: 5,
    rx: 5,
    style: {
      fill: "#f2f0ff !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52.140625, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 104.28125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p6 || (_p6 = /*#__PURE__*/React.createElement("p", null, "human_review"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.9921875, 612.71875)",
    id: "flowchart-pull_request-6",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 49.1875,
    width: 119.640625,
    y: -24.59375,
    x: -59.8203125,
    ry: 5,
    rx: 5,
    style: {
      fill: "#f2f0ff !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.8203125, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 89.640625
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p7 || (_p7 = /*#__PURE__*/React.createElement("p", null, "pull_request"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.01171875, 704.40625)",
    id: "flowchart-__end__-7",
    className: "node default last"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 34.1875,
    width: 83.5,
    y: -17.09375,
    x: -41.75,
    ry: 17.09375,
    rx: 17.09375,
    style: {
      fill: "#bfb6fc !important"
    },
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.9765625, -9.59375)",
    style: {
      lineHeight: "1.2 !important"
    },
    className: "label"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 19.1875,
    width: 59.953125
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      lineHeight: 1.5,
      display: "table-cell",
      whiteSpace: "nowrap",
      maxWidth: 200,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel",
    style: {
      lineHeight: "1.2 !important"
    }
  }, _p8 || (_p8 = /*#__PURE__*/React.createElement("p", null, "__end__")))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.c1506837df4cb368e17f1b99c8d72b5d.svg";
export { ForwardRef as ReactComponent };